import * as React from 'react';
import { Image } from 'antd';
import { useResolvedImageSrc } from '../../hooks/useResolvedImageSrc';
import ConvertingImagePlaceholder from '../converting_image_placeholder/ConvertingImagePlaceholder';
import { NoteMediaItem } from '../../utils/NoteMediaUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';

// antd's own `.ant-image-img { height: auto }` and `.ant-image { position: relative }` load after
// the Tailwind sheet and win on equal specificity, so the image is sized inline — the same way
// NoteImageGrid and ProtectedImageThumbnails size theirs.
const IMAGE_STYLE: React.CSSProperties = {
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	display: 'block',
};
const IMAGE_WRAPPER_STYLE: React.CSSProperties = { width: '100%', height: '100%' };

interface NotesMediaPhotoTileProps {
	item: NoteMediaItem;
	/** The square tile shell, plus sizing from the container. */
	className?: string;
}

/**
 * One photo in the media grid. Notes store absolute upload URLs, and a HEIC photo (an iPhone
 * upload) is converted to JPEG first so it renders outside Safari — the same normalization the
 * chat bubble's collage does. The backend's own derivative is polled for first; heic2any in this
 * tab is the fallback for when no derivative is coming.
 */
const NotesMediaPhotoTile: React.FC<NotesMediaPhotoTileProps> = ({ item, className = '' }) => {
	const resolved = useResolvedImageSrc({
		url: item.url,
		convertedImages: nullSafeGet('note.convertedImages', item),
	});

	return (
		<div className={`bg-grey-4 ${className}`}>
			<div className="absolute inset-0">
				{resolved.isConverting ? (
					<ConvertingImagePlaceholder />
				) : (
					<Image
						src={resolved.src}
						preview={{ src: resolved.previewSrc }}
						style={IMAGE_STYLE}
						wrapperStyle={IMAGE_WRAPPER_STYLE}
						alt=""
					/>
				)}
			</div>
		</div>
	);
};

export default NotesMediaPhotoTile;
